import { appConfig } from '@common/config';
import { DETAIL_STATE } from '@constants/common';
import { getDefalutImgUrl } from '@constants/config';
import { type GemItemType, getGemTypeString } from '@constants/gemType';
import { toastOption, useErrorToastMessage } from '@hook/useErrorToastMessage';
import { useSetSearchParams } from '@hook/useSetSearchParams';
import { type IDetailIndexPorps, type IDetailItemDicInfo } from '@interface/IDetail';
import { itemInfoQueryKey } from '@network/queryKeys';
import { useDataQuery, useMutate } from '@network/querys';
import { keepPreviousData } from '@tanstack/react-query';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const SecSummary = ({ props }: { props: IDetailIndexPorps }) => {
    const { t } = useTranslation();
    const { handleError } = useErrorToastMessage(t, 'summary');
    const setParams = useSetSearchParams();

    const { data: iteminfo } = useDataQuery<IDetailItemDicInfo>(
        itemInfoQueryKey,
        `/${appConfig.service}/v2.0/game/item/${props.detailId}`,
        { level: props.detailLevel },
        {
            staleTime: 5000,
            placeholderData: keepPreviousData,
            enabled: props.detailNow === DETAIL_STATE.ITEM && !!props.detailId,
        }
    );

    const [isFavorite, isFavoriteSet] = useState(iteminfo ? iteminfo?.favorite : false);

    useEffect(() => {
        if (!iteminfo) return;
        if (iteminfo?.favorite !== undefined || iteminfo?.favorite !== null) {
            isFavoriteSet(iteminfo?.favorite);
        }
    }, [iteminfo]);

    const { mutateAsync, error } = useMutate();

    const callApi = async (_isFav: boolean) => {
        if (window.isLoginFlag !== 'true') {
            window.GNBLogin?.();
            return;
        }

        try {
            await mutateAsync({
                method: _isFav ? 'post' : 'delete',
                apiPath: `/${appConfig.service}/v2.0/my/favorite/item/${props.detailId}`,
                data: null,
            });
            isFavoriteSet(_isFav);
            setParams({ favitem: `${props.detailId}_${_isFav}` });

            toast.dismiss();
            toast(
                (to) => (
                    <div className="toast-wrapper">
                        <span className="toast-title">{_isFav ? t('common.addfavs') : t('common.removefavs')}</span>
                    </div>
                ),
                toastOption
            );
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        handleError(error);
    }, [error, handleError]);

    if (!iteminfo?.name) return null;

    return (
        <section className="summary">
            <img className="thumb" src={iteminfo?.image} onError={(e) => (e.currentTarget.src = getDefalutImgUrl())} />
            <div className="spec">
                <strong className="name" data-itemgrade={iteminfo?.grade}>
                    {iteminfo?.name} {getGemTypeString(iteminfo?.category2 as GemItemType)}
                </strong>
                {!iteminfo?.tradable && <span className="tradable" title="각인" />}
                <div className="ability">
                    <span className="value" title={iteminfo?.categoryName}>
                        {iteminfo?.categoryName}
                    </span>
                    {iteminfo?.equipLevel > 1 && (
                        <span className="value" title={'요구 레벨 ' + iteminfo?.equipLevel}>
                            요구 레벨 {iteminfo?.equipLevel}
                        </span>
                    )}
                    {iteminfo?.classNames?.length > 0 && (
                        <span className="value" title={'직업 제한'}>
                            {iteminfo?.classNames.join(', ')} 전용
                        </span>
                    )}
                </div>
            </div>
            <button
                className={classNames(`btn-favorite`, { 'is-active': isFavorite })}
                data-id={iteminfo?.itemId}
                data-areas="시세_아이템상세_즐겨찾기_클릭"
                onClick={() => callApi(!isFavorite)}
            >
                {isFavorite ? '★' : '☆'}
            </button>
        </section>
    );
};
